import { CommonModule } from '@angular/common';
// tslint:disable-next-line: max-line-length
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ShimanoPaginationModule } from '../pagination/pagination.module';
import { DownloadMediaCategoryListComponent } from './download-media-category-list/download-media-category-list.component';
import { DownloadMediaComponent } from './download-media/download-media.component';
import { DownloadsComponent } from './downloads.component';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    MatIconModule,
    CommonModule,
    MediaModule,
    RouterModule,
    UrlModule,
    SlickCarouselModule,
    I18nModule,
    ShimanoPaginationModule,
    FormsModule,
    MatMenuModule,
    DownloadsComponent,
    DownloadMediaComponent,
    DownloadMediaCategoryListComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoManualMediaListComponent: {
          component: DownloadsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class DownloadsModule {}
